import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { FundraiserService } from 'src/app/pages/fundraiser/services/fundraiser.service';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { MatButtonModule } from '@angular/material/button';
import { FlexModule } from '@angular/flex-layout/flex';

@Component({
    selector: 'app-delete-offline-donation',
    templateUrl: './delete-offline-donation.component.html',
    standalone: true,
    imports: [FlexModule, MatButtonModule, MatDialogModule]
})
export class DeleteOfflineDonationComponent {
	constructor(
		@Inject(MAT_DIALOG_DATA)
		public data: {
			id: number;
		},
		public fundraiserService: FundraiserService,
		public dialogRef: MatDialogRef<DeleteOfflineDonationComponent>,
		public notificationService: NotificationService
	) {}

	onCloseClick() {
		this.dialogRef.close();
	}

	onDeleteOfflineDonation(id: number) {
		this.fundraiserService
			.deleteOfflineDonation(id)
			.subscribe((response: any) => {
				this.fundraiserService.setOfflineDonation();
				this.dialogRef.close();
				this.notificationService.openNotification(
					$localize`:@@fundraiser_update_edit_fundraiserUpdateDeleted_notification: Delete successful.`,
					'OK',
					'success'
				);
			},
			(error) => {
				this.notificationService.openNotification(
				  $localize`:@@fundraiser_update_edit_fundraiserUpdateDeleted_error:An error occurred while deleting the update`,
				  'OK',
				  'error'
				);
			
	});
	}
}
